import React, { useState } from "react";
import BuyPlan from "./PlanPurchase/BuyPlan";
import { Link } from "react-router-dom";
import HealthPlanComparison from "../components/HealthPlanComparison";

const PlanPage = () => {
  const [openPopup, setOpenPopup] = useState(false);
  const [planCode, setPlanCode] = useState("");
  const [tenantId, setTenantId] = useState("T3673001XTD");
  const [isRider, setIsRider] = useState(false);
  const [showMember, setShowMember] = useState(false);
  const [memberCount, setMemberCount] = useState(0);
  const [showRC, setShowRC] = useState(false);

  return (
    <div>
      {/* ======= Pricing =======*/}
      <section className="section pricing__v2 cu_mtpd" id="pricing">
        <div className="container">
          <div className="row mb-5">
            <div className="col-md-5 mx-auto text-center">
              <span
                className="subtitle text-uppercase mb-3"
                data-aos="fade-up"
                data-aos-delay={0}
              >
                Plans
              </span>
              <h2 className="mb-3 text-[32px]" data-aos="fade-up" data-aos-delay={100}>
                Explore Plans for Your Families
              </h2>
              <p data-aos="fade-up" data-aos-delay={200}>
                A smarter, stress-free approach to OPD and wellness care.
              </p>
            </div>
          </div>



          <div className="row">
            <div className="col-md-6 mb-4" data-aos="fade-up" data-aos-delay={300}>
              <div className="p-5 rounded-4 price-table h-100">
                <span
                  className="subtitle text-uppercase mb-3"
                  data-aos="fade-up"
                  data-aos-delay={0}
                >
                  Platinum Plan
                </span>
                <span
                  className="subtitle text-uppercase mb-3 ml-3"
                  data-aos="fade-up"
                  data-aos-delay={0}
                >
                  Coverage: 2A & 2C
                </span>
                <div className="price mb-2">
                  <strong>₹9,999</strong>
                  <span>+ GST</span>
                </div>
                <div className="mx-btn w-fit"
                  onClick={() => {
                    setPlanCode("VedanaCarePlatinum");
                    setOpenPopup(true);
                    setIsRider(true);
                    setMemberCount(3);
                    setShowMember(false);
                    setShowRC(false);
                  }}>
                  Buy Plan
                  <svg className="icon" viewBox="0 0 24 24" fill="currentColor">
                    <path
                      fillRule="evenodd"
                      d="M12 2.25c-5.385 0-9.75 4.365-9.75 9.75s4.365 9.75 9.75 9.75 9.75-4.365 9.75-9.75S17.385 2.25 12 2.25zm4.28 10.28a.75.75 0 000-1.06l-3-3a.75.75 0 10-1.06 1.06l1.72 1.72H8.25a.75.75 0 000 1.5h5.69l-1.72 1.72a.75.75 0 101.06 1.06l3-3z"
                      clipRule="evenodd"
                    />
                  </svg>
                </div>
                <div className="col-md-12 mt-[30px] pricing-features">
                  <h4 className="text-uppercase fw-bold mb-3">What's included</h4>
                  <ul className="list-unstyled mb-3 d-flex flex-column gap-3">
                    <li className="d-flex gap-2 align-items-start mb-0">
                      <span className="icon rounded-circle position-relative mt-1">
                        <i className="bi bi-check" />
                      </span>
                      <span>Unlimited on Tele Doctor Consultation: GP </span>
                    </li>
                    <li className="d-flex gap-2 align-items-start mb-0">
                      <span className="icon rounded-circle position-relative mt-1">
                        <i className="bi bi-check" />
                      </span>
                      <span>4 Credits on Tele Doctor Consultation: Ayurvedic</span>
                    </li>
                    <li className="d-flex gap-2 align-items-start mb-0">
                      <span className="icon rounded-circle position-relative mt-1">
                        <i className="bi bi-check" />
                      </span>
                      <span>4 Credits on Tele Doctor Consultation: Homeopathy</span>
                    </li>
                    <li className="d-flex gap-2 align-items-start mb-0">
                      <span className="icon rounded-circle position-relative mt-1">
                        <i className="bi bi-check" />
                      </span>
                      <span>4 Credits on Tele Doctor Consultation: 18+ Specialist</span>
                    </li>
                    <li className="d-flex gap-2 align-items-start mb-0">
                      <span className="icon rounded-circle position-relative mt-1">
                        <i className="bi bi-check" />
                      </span>
                      <span>2 credits - Full Body Checkup (56 parameters)</span>
                    </li>
                    <li className="d-flex gap-2 align-items-start mb-0">
                      <span className="icon rounded-circle position-relative mt-1">
                        <i className="bi bi-check" />
                      </span>
                      <span>4 Credit or ₹500 Reimbursement on In-person General Physician Clinic & Hospital Consultation / My Choice Doctor</span>
                    </li>
                    <li className="d-flex gap-2 align-items-start mb-0">
                      <span className="icon rounded-circle position-relative mt-1">
                        <i className="bi bi-check" />
                      </span>
                      <span>4 Credit on General Physician/CP Video Consultation</span>
                    </li>
                    <li className="d-flex gap-2 align-items-start mb-0">
                      <span className="icon rounded-circle position-relative mt-1">
                        <i className="bi bi-check" />
                      </span>
                      <span>4 Credit on Dental Check-up and Consultation</span>
                    </li>
                    <li className="d-flex gap-2 align-items-start mb-0">
                      <span className="icon rounded-circle position-relative mt-1">
                        <i className="bi bi-check" />
                      </span>
                      <span>4 Credit on Mental Wellness</span>
                    </li>
                    <li className="d-flex gap-2 align-items-start mb-0">
                      <span className="icon rounded-circle position-relative mt-1">
                        <i className="bi bi-check" />
                      </span>
                      <span>4 Credit on Tele Dietician Consultation</span>
                    </li>
                    <li className="d-flex gap-2 align-items-start mb-0">
                      <span className="icon rounded-circle position-relative mt-1">
                        <i className="bi bi-check" />
                      </span>
                      <span>1 Credit on Pet Care</span>
                    </li>
                  </ul>
                  <h4 className="text-uppercase fw-bold mb-3">Group Personal Accident Rider</h4>
                  <ul className="list-unstyled mb-3 d-flex flex-column gap-3">
                    <li className="d-flex gap-2 align-items-start mb-0">
                      <span className="icon rounded-circle position-relative mt-1">
                        <i className="bi bi-check" />
                      </span>
                      <span>₹15 Lakh Sum Insured </span>
                    </li>
                    <li className="d-flex gap-2 align-items-start mb-0">
                      <span className="icon rounded-circle position-relative mt-1">
                        <i className="bi bi-check" />
                      </span>
                      <span>Covered Accidental Death  </span>
                    </li>
                    <li className="d-flex gap-2 align-items-start mb-0">
                      <span className="icon rounded-circle position-relative mt-1">
                        <i className="bi bi-check" />
                      </span>
                      <span>Covered Permanent Total Disability (Upto 100% SI Paid on PTD)</span>
                    </li>
                  </ul>
                  
                  <h4 className="text-uppercase fw-bold mb-3">Inclusive Benefits</h4>
                  <ul className="list-unstyled mb-3 d-flex flex-column gap-3">
                    <li className="d-flex gap-2 align-items-start mb-0">
                      <span className="icon rounded-circle position-relative mt-1">
                        <i className="bi bi-check" />
                      </span>
                      <span>Applicable Risk Assessment </span>
                    </li>
                    <li className="d-flex gap-2 align-items-start mb-0">
                      <span className="icon rounded-circle position-relative mt-1">
                        <i className="bi bi-check" />
                      </span>
                      <span>Applicable Health Reminder</span>
                    </li>
                    <li className="d-flex gap-2 align-items-start mb-0">
                      <span className="icon rounded-circle position-relative mt-1">
                        <i className="bi bi-check" />
                      </span>
                      <span>Applicable Recorded Fitness sessions</span>
                    </li>
                  </ul>
                  <h4 className="text-uppercase fw-bold mb-3">Platform Benefits</h4>
                  <ul className="list-unstyled mb-3 d-flex flex-column gap-3">
                    <li className="d-flex gap-2 align-items-start mb-0">
                      <span className="icon rounded-circle position-relative mt-1">
                        <i className="bi bi-check" />
                      </span>
                      <span>₹50,000 Upto 50% off on diagnostic test & packages </span>
                    </li>
                    <li className="d-flex gap-2 align-items-start mb-0">
                      <span className="icon rounded-circle position-relative mt-1">
                        <i className="bi bi-check" />
                      </span>
                      <span>₹20,000 Upto 20% off on Prescribed Medicines</span>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            <div className="col-md-6 mb-4" data-aos="fade-up" data-aos-delay={300}>
              <div className="p-5 rounded-4 price-table h-100">
                <span
                  className="subtitle text-uppercase mb-3"
                  data-aos="fade-up"
                  data-aos-delay={0}
                >
                  Gold Plan
                </span>
                <span
                  className="subtitle text-uppercase mb-3 ml-3"
                  data-aos="fade-up"
                  data-aos-delay={0}
                >
                  Coverage: 2A & 2C
                </span>
                <div className="price mb-2">
                  <strong>₹4,999</strong>
                  <span>+ GST</span>
                </div>
                <div className="mx-btn w-fit"
                  onClick={() => {
                    setPlanCode("VedanaCareGold");
                    setOpenPopup(true);
                    setIsRider(true);
                    setMemberCount(3);
                    setShowMember(false);
                    setShowRC(false);
                  }}>
                  Buy Plan
                  <svg className="icon" viewBox="0 0 24 24" fill="currentColor">
                    <path
                      fillRule="evenodd"
                      d="M12 2.25c-5.385 0-9.75 4.365-9.75 9.75s4.365 9.75 9.75 9.75 9.75-4.365 9.75-9.75S17.385 2.25 12 2.25zm4.28 10.28a.75.75 0 000-1.06l-3-3a.75.75 0 10-1.06 1.06l1.72 1.72H8.25a.75.75 0 000 1.5h5.69l-1.72 1.72a.75.75 0 101.06 1.06l3-3z"
                      clipRule="evenodd"
                    />
                  </svg>
                </div>
                <div className="col-md-12 mt-[30px] pricing-features">
                  <h4 className="text-uppercase fw-bold mb-3">What's included</h4>
                  <ul className="list-unstyled mb-3 d-flex flex-column gap-3">
                    <li className="d-flex gap-2 align-items-start mb-0">
                      <span className="icon rounded-circle position-relative mt-1">
                        <i className="bi bi-check" />
                      </span>
                      <span>12 Credits on Tele Doctor Consultation: GP </span>
                    </li>
                    <li className="d-flex gap-2 align-items-start mb-0">
                      <span className="icon rounded-circle position-relative mt-1">
                        <i className="bi bi-check" />
                      </span>
                      <span>2 Credits on Tele Doctor Consultation: Ayurvedic</span>
                    </li>
                    <li className="d-flex gap-2 align-items-start mb-0">
                      <span className="icon rounded-circle position-relative mt-1">
                        <i className="bi bi-check" />
                      </span>
                      <span>2 Credits on Tele Doctor Consultation: Homeopathy</span>
                    </li>
                    <li className="d-flex gap-2 align-items-start mb-0">
                      <span className="icon rounded-circle position-relative mt-1">
                        <i className="bi bi-check" />
                      </span>
                      <span>4 Credits on Tele Doctor Consultation: 18+ Specialist</span>
                    </li>
                    <li className="d-flex gap-2 align-items-start mb-0">
                      <span className="icon rounded-circle position-relative mt-1">
                        <i className="bi bi-check" />
                      </span>
                      <span>2 credit 50% discount - Full Body Checkup (56 parameters)</span>
                    </li>
                    <li className="d-flex gap-2 align-items-start mb-0">
                      <span className="icon rounded-circle position-relative mt-1">
                        <i className="bi bi-check" />
                      </span>
                      <span>2 Credit or ₹500 Reimbursement on In-person General Physician Clinic & Hospital Consultation / My Choice Doctor</span>
                    </li>
                    <li className="d-flex gap-2 align-items-start mb-0">
                      <span className="icon rounded-circle position-relative mt-1">
                        <i className="bi bi-check" />
                      </span>
                      <span>4 Credit on General Physician/CP Video Consultation</span>
                    </li>
                    <li className="d-flex gap-2 align-items-start mb-0">
                      <span className="icon rounded-circle position-relative mt-1">
                        <i className="bi bi-check" />
                      </span>
                      <span>2 Credit on Dental Check-up and Consultation</span>
                    </li>
                    <li className="d-flex gap-2 align-items-start mb-0">
                      <span className="icon rounded-circle position-relative mt-1">
                        <i className="bi bi-check" />
                      </span>
                      <span>2 Credit on Mental Wellness</span>
                    </li>
                    <li className="d-flex gap-2 align-items-start mb-0">
                      <span className="icon rounded-circle position-relative mt-1">
                        <i className="bi bi-check" />
                      </span>
                      <span>2 Credit on Tele Dietician Consultation</span>
                    </li>
                  </ul>
                  <h4 className="text-uppercase fw-bold mb-3">Group Personal Accident Rider</h4>
                  <ul className="list-unstyled mb-3 d-flex flex-column gap-3">
                    <li className="d-flex gap-2 align-items-start mb-0">
                      <span className="icon rounded-circle position-relative mt-1">
                        <i className="bi bi-check" />
                      </span>
                      <span>₹15 Lakh Sum Insured </span>
                    </li>
                    <li className="d-flex gap-2 align-items-start mb-0">
                      <span className="icon rounded-circle position-relative mt-1">
                        <i className="bi bi-check" />
                      </span>
                      <span>Covered Accidental Death  </span>
                    </li>
                    <li className="d-flex gap-2 align-items-start mb-0">
                      <span className="icon rounded-circle position-relative mt-1">
                        <i className="bi bi-check" />
                      </span>
                      <span>Covered Permanent Total Disability (Upto 100% SI Paid on PTD)</span>
                    </li>
                  </ul>
                  <h4 className="text-uppercase fw-bold mb-3">Inclusive Benefits</h4>
                  <ul className="list-unstyled mb-3 d-flex flex-column gap-3">
                    <li className="d-flex gap-2 align-items-start mb-0">
                      <span className="icon rounded-circle position-relative mt-1">
                        <i className="bi bi-check" />
                      </span>
                      <span>Applicable Risk Assessment </span>
                    </li>
                    <li className="d-flex gap-2 align-items-start mb-0">
                      <span className="icon rounded-circle position-relative mt-1">
                        <i className="bi bi-check" />
                      </span>
                      <span>Applicable Health Reminder</span>
                    </li>
                    <li className="d-flex gap-2 align-items-start mb-0">
                      <span className="icon rounded-circle position-relative mt-1">
                        <i className="bi bi-check" />
                      </span>
                      <span>Applicable Recorded Fitness sessions</span>
                    </li>
                  </ul>
                  <h4 className="text-uppercase fw-bold mb-3">Platform Benefits</h4>
                  <ul className="list-unstyled mb-3 d-flex flex-column gap-3">
                    <li className="d-flex gap-2 align-items-start mb-0">
                      <span className="icon rounded-circle position-relative mt-1">
                        <i className="bi bi-check" />
                      </span>
                      <span>₹20,000 Upto 50% off on diagnostic test & packages </span>
                    </li>
                    <li className="d-flex gap-2 align-items-start mb-0">
                      <span className="icon rounded-circle position-relative mt-1">
                        <i className="bi bi-check" />
                      </span>
                      <span>₹10,000 Upto 20% off on Prescribed Medicines</span>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            <div className="col-md-6 mb-4" data-aos="fade-up" data-aos-delay={300}>
              <div className="p-5 rounded-4 price-table h-100">
                <span
                  className="subtitle text-uppercase mb-3"
                  data-aos="fade-up"
                  data-aos-delay={0}
                >
                  Silver Plan
                </span>
                <span
                  className="subtitle text-uppercase mb-3 ml-3"
                  data-aos="fade-up"
                  data-aos-delay={0}
                >
                  Coverage: Individual
                </span>
                <div className="price mb-2">
                  <strong>₹1,999</strong>
                  <span>+ GST</span>
                </div>
                <div className="mx-btn w-fit"
                  onClick={() => {
                    setPlanCode("VedanaCareSilver");
                    setOpenPopup(true);
                    setIsRider(true);
                    setMemberCount(0);
                    setShowMember(false);
                    setShowRC(false);
                  }}>
                  Buy Plan
                  <svg className="icon" viewBox="0 0 24 24" fill="currentColor">
                    <path
                      fillRule="evenodd"
                      d="M12 2.25c-5.385 0-9.75 4.365-9.75 9.75s4.365 9.75 9.75 9.75 9.75-4.365 9.75-9.75S17.385 2.25 12 2.25zm4.28 10.28a.75.75 0 000-1.06l-3-3a.75.75 0 10-1.06 1.06l1.72 1.72H8.25a.75.75 0 000 1.5h5.69l-1.72 1.72a.75.75 0 101.06 1.06l3-3z"
                      clipRule="evenodd"
                    />
                  </svg>
                </div>
                <div className="col-md-12 mt-[30px] pricing-features">
                  <h4 className="text-uppercase fw-bold mb-3">What's included</h4>
                  <ul className="list-unstyled mb-3 d-flex flex-column gap-3">
                    <li className="d-flex gap-2 align-items-start mb-0">
                      <span className="icon rounded-circle position-relative mt-1">
                        <i className="bi bi-check" />
                      </span>
                      <span>12 Credits on Tele Doctor Consultation: GP </span>
                    </li>
                    <li className="d-flex gap-2 align-items-start mb-0">
                      <span className="icon rounded-circle position-relative mt-1">
                        <i className="bi bi-check" />
                      </span>
                      <span>Upto 50% off on 2 Credits - Full Body Checkup (56 parameters)</span>
                    </li>
                    <li className="d-flex gap-2 align-items-start mb-0">
                      <span className="icon rounded-circle position-relative mt-1">
                        <i className="bi bi-check" />
                      </span>
                      <span>₹20,000 Upto 50% discount on Diagnostic & Radiology Wallet</span>
                    </li>
                    <li className="d-flex gap-2 align-items-start mb-0">
                      <span className="icon rounded-circle position-relative mt-1">
                        <i className="bi bi-check" />
                      </span>
                      <span>4 Credit on General Physician/CP Video Consultation</span>
                    </li>
                    <li className="d-flex gap-2 align-items-start mb-0">
                      <span className="icon rounded-circle position-relative mt-1">
                        <i className="bi bi-check" />
                      </span>
                      <span>₹5000 - upto 20% Discounted Platform on Pharmacy Wallet - Prescribed Medicines</span>
                    </li>
                    <li className="d-flex gap-2 align-items-start mb-0">
                      <span className="icon rounded-circle position-relative mt-1">
                        <i className="bi bi-check" />
                      </span>
                      <span>4 Credit on Mental Wellness</span>
                    </li>
                    <li className="d-flex gap-2 align-items-start mb-0">
                      <span className="icon rounded-circle position-relative mt-1">
                        <i className="bi bi-check" />
                      </span>
                      <span>2 Credit on Tele Dietician Consultation</span>
                    </li>
                  </ul>
                  <h4 className="text-uppercase fw-bold mb-3">Group Personal Accident Rider</h4>
                  <ul className="list-unstyled mb-3 d-flex flex-column gap-3">
                    <li className="d-flex gap-2 align-items-start mb-0">
                      <span className="icon rounded-circle position-relative mt-1">
                        <i className="bi bi-check" />
                      </span>
                      <span>₹15 Lakh Sum Insured </span>
                    </li>
                    <li className="d-flex gap-2 align-items-start mb-0">
                      <span className="icon rounded-circle position-relative mt-1">
                        <i className="bi bi-check" />
                      </span>
                      <span>Covered Accidental Death  </span>
                    </li>
                    <li className="d-flex gap-2 align-items-start mb-0">
                      <span className="icon rounded-circle position-relative mt-1">
                        <i className="bi bi-check" />
                      </span>
                      <span>Covered Permanent Total Disability (Upto 100% SI Paid on PTD)</span>
                    </li>
                  </ul>
                  <h4 className="text-uppercase fw-bold mb-3">Inclusive Benefits</h4>
                  <ul className="list-unstyled mb-3 d-flex flex-column gap-3">
                    <li className="d-flex gap-2 align-items-start mb-0">
                      <span className="icon rounded-circle position-relative mt-1">
                        <i className="bi bi-check" />
                      </span>
                      <span>Applicable Risk Assessment </span>
                    </li>
                    <li className="d-flex gap-2 align-items-start mb-0">
                      <span className="icon rounded-circle position-relative mt-1">
                        <i className="bi bi-check" />
                      </span>
                      <span>Applicable Health Reminder</span>
                    </li>
                    <li className="d-flex gap-2 align-items-start mb-0">
                      <span className="icon rounded-circle position-relative mt-1">
                        <i className="bi bi-check" />
                      </span>
                      <span>Applicable Recorded Fitness sessions</span>
                    </li>
                  </ul>
                  <h4 className="text-uppercase fw-bold mb-3">Platform Benefits</h4>
                  <ul className="list-unstyled mb-3 d-flex flex-column gap-3">
                    <li className="d-flex gap-2 align-items-start mb-0">
                      <span className="icon rounded-circle position-relative mt-1">
                        <i className="bi bi-check" />
                      </span>
                      <span>Upto 50% off on diagnostic test & packages (20000 diagnostics test up 50% discount) </span>
                    </li>
                    <li className="d-flex gap-2 align-items-start mb-0">
                      <span className="icon rounded-circle position-relative mt-1">
                        <i className="bi bi-check" />
                      </span>
                      <span>Upto 20% off on prescribed medicines</span>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            <div className="col-md-6 mb-4" data-aos="fade-up" data-aos-delay={300}>
              <div className="p-5 rounded-4 price-table h-100">
                <span
                  className="subtitle text-uppercase mb-3"
                  data-aos="fade-up"
                  data-aos-delay={0}
                >
                  Basic Plan
                </span>
                <span
                  className="subtitle text-uppercase mb-3 ml-3"
                  data-aos="fade-up"
                  data-aos-delay={0}
                >
                  Coverage: Individual
                </span>
                <div className="price mb-2">
                  <strong>₹999</strong>
                  <span>+ GST</span>
                </div>
                <div className="mx-btn w-fit"
                  onClick={() => {
                    setPlanCode("VedanaCareBasic");
                    setOpenPopup(true);
                    setIsRider(true);
                    setMemberCount(0);
                    setShowMember(false);
                    setShowRC(false);
                  }}>
                  Buy Plan
                  <svg className="icon" viewBox="0 0 24 24" fill="currentColor">
                    <path
                      fillRule="evenodd"
                      d="M12 2.25c-5.385 0-9.75 4.365-9.75 9.75s4.365 9.75 9.75 9.75 9.75-4.365 9.75-9.75S17.385 2.25 12 2.25zm4.28 10.28a.75.75 0 000-1.06l-3-3a.75.75 0 10-1.06 1.06l1.72 1.72H8.25a.75.75 0 000 1.5h5.69l-1.72 1.72a.75.75 0 101.06 1.06l3-3z"
                      clipRule="evenodd"
                    />
                  </svg>
                </div>
                <div className="col-md-12 mt-[30px] pricing-features">
                  <h4 className="text-uppercase fw-bold mb-3">What's included</h4>
                  <ul className="list-unstyled mb-3 d-flex flex-column gap-3">
                    <li className="d-flex gap-2 align-items-start mb-0">
                      <span className="icon rounded-circle position-relative mt-1">
                        <i className="bi bi-check" />
                      </span>
                      <span>6 Credits on Tele Doctor Consultation: GP </span>
                    </li>
                    <li className="d-flex gap-2 align-items-start mb-0">
                      <span className="icon rounded-circle position-relative mt-1">
                        <i className="bi bi-check" />
                      </span>
                      <span>2 Credits on Tele Doctor Consultation: Ayurveda </span>
                    </li>
                    <li className="d-flex gap-2 align-items-start mb-0">
                      <span className="icon rounded-circle position-relative mt-1">
                        <i className="bi bi-check" />
                      </span>
                      <span>2 Credits on Tele Doctor Consultation: Homeopathy  </span>
                    </li>
                    <li className="d-flex gap-2 align-items-start mb-0">
                      <span className="icon rounded-circle position-relative mt-1">
                        <i className="bi bi-check" />
                      </span>
                      <span>Upto 50% off on 2 Credits - Full Body Checkup (56 parameters)</span>
                    </li>
                    <li className="d-flex gap-2 align-items-start mb-0">
                      <span className="icon rounded-circle position-relative mt-1">
                        <i className="bi bi-check" />
                      </span>
                      <span>1 Credit on Dental Checkup & Consultation</span>
                    </li>
                  </ul>
                  <h4 className="text-uppercase fw-bold mb-3">Group Personal Accident Rider</h4>
                  <ul className="list-unstyled mb-3 d-flex flex-column gap-3">
                    <li className="d-flex gap-2 align-items-start mb-0">
                      <span className="icon rounded-circle position-relative mt-1">
                        <i className="bi bi-check" />
                      </span>
                      <span>₹15 Lakh Sum Insured </span>
                    </li>
                    <li className="d-flex gap-2 align-items-start mb-0">
                      <span className="icon rounded-circle position-relative mt-1">
                        <i className="bi bi-check" />
                      </span>
                      <span>Covered Accidental Death  </span>
                    </li>
                    <li className="d-flex gap-2 align-items-start mb-0">
                      <span className="icon rounded-circle position-relative mt-1">
                        <i className="bi bi-check" />
                      </span>
                      <span>Covered Permanent Total Disability (Upto 100% SI Paid on PTD)</span>
                    </li>
                  </ul>
                  <h4 className="text-uppercase fw-bold mb-3">Inclusive Benefits</h4>
                  <ul className="list-unstyled mb-3 d-flex flex-column gap-3">
                    <li className="d-flex gap-2 align-items-start mb-0">
                      <span className="icon rounded-circle position-relative mt-1">
                        <i className="bi bi-check" />
                      </span>
                      <span>Applicable Risk Assessment </span>
                    </li>
                    <li className="d-flex gap-2 align-items-start mb-0">
                      <span className="icon rounded-circle position-relative mt-1">
                        <i className="bi bi-check" />
                      </span>
                      <span>Applicable Health Reminder</span>
                    </li>
                    <li className="d-flex gap-2 align-items-start mb-0">
                      <span className="icon rounded-circle position-relative mt-1">
                        <i className="bi bi-check" />
                      </span>
                      <span>Applicable Recorded Fitness sessions</span>
                    </li>
                  </ul>
                  <h4 className="text-uppercase fw-bold mb-3">Platform Benefits</h4>
                  <ul className="list-unstyled mb-3 d-flex flex-column gap-3">
                    <li className="d-flex gap-2 align-items-start mb-0">
                      <span className="icon rounded-circle position-relative mt-1">
                        <i className="bi bi-check" />
                      </span>
                      <span>₹20,000 Upto 50% off on diagnostic test & packages </span>
                    </li>
                    <li className="d-flex gap-2 align-items-start mb-0">
                      <span className="icon rounded-circle position-relative mt-1">
                        <i className="bi bi-check" />
                      </span>
                      <span>₹10,000 Upto 20% off on Prescribed Medicines</span>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* End Pricing*/}

      <BuyPlan
        planCode={planCode}
        tenantId={tenantId}
        showPopUp={openPopup}
        setShowPopUp={setOpenPopup}
        isRider={isRider}
        showMember={showMember}
        memberCount={memberCount}
        showRC={showRC}
      />
    </div>
  );
};

export default PlanPage;
